import {
  OrganizationDatatableColumnId,
  OrganizationPerimetersFilterId,
} from '@/contexts/organization/Organization.interfaces'
import { PerimetersSortField, PerimeterTypeWithTag } from '@/contexts/perimeters/Perimeters.interfaces'
import {
  DatatableSortingOrderBy,
  type DatatableSorting,
} from '@/components/NewDesignSystem/NdsDatatable/NdsDatatable.interfaces'

export const ORGANIZATION_ROUTE_NAME = 'organization_views'
export const ORGANIZATION_TREE_ROUTE_NAME = 'organization_tree'
export const ORGANIZATION_PERIMETERS_LIST_ROUTE_NAME = 'organization_perimeters_list'
export const ORGANIZATION_FILTERED_ROUTE_NAME = 'filtered_perimeter'
export const ORGANIZATION_TREE_SELECTION_KEY = 'perimeters'
export const ORGANIZATION_IMPORT_EXPORT_MODAL_ID = 'import_perimeter'
export const ORGANIZATION_ADD_TREE_PANEL_ID = 'organization_add_tree'

export const ORGANIZATION_PERIMETERS_FILTER_ID = {
  ...OrganizationPerimetersFilterId,
}

export const ORGANIZATION_PERIMETER_TYPES: Readonly<PerimeterTypeWithTag[]> = [
  PerimeterTypeWithTag.TAG,
  PerimeterTypeWithTag.INTERNAL,
  PerimeterTypeWithTag.APPLICATION,
  PerimeterTypeWithTag.PROVIDER,
]

export const ORGANIZATION_ADD_MENU_PERIMETER_TYPES: Readonly<PerimeterTypeWithTag[]> = [
  PerimeterTypeWithTag.INTERNAL,
  PerimeterTypeWithTag.APPLICATION,
  PerimeterTypeWithTag.PROVIDER,
  PerimeterTypeWithTag.TAG,
]

export const ORGANIZATION_VIEWS = {
  LIST: 'list',
  TREE: 'tree',
} as const

export const PERIMETERS_SORT_FIELD_BY_COLUMN_ID: Readonly<
  Partial<Record<OrganizationDatatableColumnId, PerimetersSortField>>
> = {
  [OrganizationDatatableColumnId.IDENTIFIER]: PerimetersSortField.IDENTIFIER,
  [OrganizationDatatableColumnId.NAME]: PerimetersSortField.NAME,
  [OrganizationDatatableColumnId.TYPE]: PerimetersSortField.TYPE,
}

export const DEFAULT_PERIMETERS_SORTING: Readonly<DatatableSorting> = {
  columnId: OrganizationDatatableColumnId.NAME,
  orderBy: DatatableSortingOrderBy.ASC,
}
